var React = require('react');

function LeadIconChevron (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"strokeWidth":"2","fillRule":"nonzero","points":"1,1 9,16 1,31 41,31 49,16 41,1","strokeLinejoin":"round"}));
}

LeadIconChevron.defaultProps = {"viewBox":"0 0 50 32"};

module.exports = LeadIconChevron;

LeadIconChevron.default = LeadIconChevron;
